import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import PropertySection from './section-components/recent-properties-for-sold';
import TopAuthor from './section-components/top-author';
import Footer from './global-components/footer';
import BlogContact from '../utils/blogContact';

const AvailableProperty = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Recent Propeties For Sold" subheader="Recent Sold" />
        <PropertySection />
        <TopAuthor />
        <div style={{paddingBottom : '35px'}}>
       <BlogContact />
    </div>
        <Footer />
    </div>
}

export default AvailableProperty

